import { useState, useEffect } from 'react'

interface MobileDetection {
  isMobile: boolean
  isInWalletBrowser: boolean
}

export function useIsMobile(): MobileDetection {
  const [detection, setDetection] = useState<MobileDetection>({
    isMobile: false,
    isInWalletBrowser: false,
  })

  useEffect(() => {
    const checkMobile = () => {
      // Check for mobile user agent
      const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera
      const mobileRegex = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i
      
      // Also check for touch capability and screen size as fallbacks
      const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0
      const isSmallScreen = window.innerWidth <= 768
      
      const isMobile = mobileRegex.test(userAgent.toLowerCase()) || (isTouchDevice && isSmallScreen)

      // Check if we're inside a wallet's in-app browser
      // These wallets inject their provider when viewing in their browser
      const win = window as any
      const isInWalletBrowser = !!(
        win.phantom?.solana?.isPhantom ||
        win.solflare?.isSolflare ||
        win.backpack?.isBackpack ||
        win.glow?.isGlow ||
        // Check for generic injected solana provider on mobile
        (isMobile && win.solana?.isConnected !== undefined)
      )

      setDetection({ isMobile, isInWalletBrowser })
    }

    checkMobile()
    
    // Also check after a small delay since wallet providers may inject async
    const timeout = setTimeout(checkMobile, 100)
    
    window.addEventListener('resize', checkMobile)
    
    return () => {
      window.removeEventListener('resize', checkMobile)
      clearTimeout(timeout)
    }
  }, [])

  return detection
}
